import { createSelector } from 'reselect';

const selectPolicyDomain = (state) => state.policy;

export const selectCancellationResult = () =>
    createSelector(selectPolicyDomain, (substate) => {
        return substate.cancellationResult;
    });
